import axios from '../../../services/axios';
import { axiosNT, axiosNTL, axiosNL } from '../../../services/axios';
import NotificationBody from '../types/NotificationBody';

const readNotification = (limit: number, skip: number) => axiosNTL
	.patch(`/notification/readNotification`, { limit, skip })
	.then((res: any) => {
		const notification: any = res.responseObject;
		return Promise.resolve(notification.data)
	});

const getNotificationsCount = () => axiosNTL
	.get(`/notification/getNotificationsCount`)
	.then((res: any) => {
		if(res){
			const count: any = res.responseObject;
			return Promise.resolve(count.unreadCount)
		}
		
	});

export default {
	readNotification,
	getNotificationsCount,
};